var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6784 9.07163C10.0123 9.0732 9.35022 8.94613 8.71735 8.69528C8.42142 8.57059 8.09262 8.6546 7.86399 8.91332L6.62222 10.0437C5.28864 9.23581 4.20658 7.93038 3.53678 6.3213L4.44883 4.85899C4.6791 4.58094 4.76145 4.17106 4.66232 3.79663C4.45365 3.03192 4.34778 2.23186 4.3487 1.42679C4.3487 0.851567 3.96226 0.385254 3.48556 0.385254H1.47154C0.994845 0.385254 0.608398 0.851567 0.608398 1.42679C0.614737 8.13455 5.11952 13.5703 10.6784 13.578C11.1551 13.578 11.5416 13.1117 11.5416 12.5365V10.1132C11.5416 9.53795 11.1551 9.07163 10.6784 9.07163Z",
    fill: "#009688"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6a252c8ef14238946814034c6db7cdf9.svg";
export { ForwardRef as ReactComponent };